import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import dataReducer from '@/store/slice/data'
import markerReducer from '@/store/slice/marker'


export default configureStore({
  reducer: {
    data: dataReducer,
    marker: markerReducer
  },
  // why should add serializableCheck attr: https://github.com/rt2zz/redux-persist/issues/988
  middleware: getDefaultMiddleware({
      serializableCheck: false
  })
})
